import { c as _c } from "react/compiler-runtime";
import React from "react";
interface DirectionIconProps {
  size?: number;
  className?: string;
  rotate?: number;
}
const DirectionIcon = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className,
    rotate: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const rotate = t2 === undefined ? 0 : t2;
  const t3 = `dynamic-size ${className}`;
  const t4 = `rotate(${rotate}deg)`;
  let t5;
  if ($[0] !== size || $[1] !== t4) {
    t5 = {
      "--width": size,
      "--height": size,
      transform: t4
    };
    $[0] = size;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <path fillRule="evenodd" clipRule="evenodd" d="M15.2929 3.49268L16.7071 4.90689L9.63605 11.978L16.7071 19.049L15.2929 20.4632L7.5148 12.6851C7.51475 12.6851 7.51473 12.6851 8.22184 11.978L7.5148 12.6851L6.80763 11.978L15.2929 3.49268Z" fill="currentColor" strokeWidth="1.5" />;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3 || $[5] !== t6) {
    t8 = <svg className={t3} style={t6} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">{t7}</svg>;
    $[4] = t3;
    $[5] = t6;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};
export default DirectionIcon;